import React, {PureComponent} from 'react';
import $ from 'jquery';
import {
    subscribeToLapInfo,
    subscribeToTelemetry,
    subscribeCarToServer,
    subscribeToStandingsInfo,
    subscribeOrgCommands,
    subscribeDashToServer,
    connectSocket,
    forceReconnect,
    closeSocket,
    subscribeSessionStatus,
} from "./functions/api";
import {withTranslation} from "react-i18next";
import {withCookies} from 'react-cookie';
import parallel from "async/parallel";
import {Redirect} from "react-router";
import Alert from 'react-s-alert';
import ReactTooltip from "react-tooltip";
import Moment from "moment-timezone";

import CarTables from './mainComponents/sideTablesComponent';
import HeaderRow from './mainComponents/headerRowComponent';
import TopRow from './mainComponents/topRowComponent';
import MiddleRow from './mainComponents/middleRowComponent';
import BottomRow from './mainComponents/bottomRowComponent';
import PopoutLapTimes from "./popoutComponents/lapTimes";
import OrganizerPanel from "./popoutComponents/organizerPanel";
import {formatTime} from "./functions/utils";
import PortraitModal from "./independentComponents/portraitModalComponent";
import FlagModal from "./independentComponents/flagModalComponent";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

const telemetryIP = process.env.REACT_APP_TELEMETRY_IP;
const telemetryPort = process.env.REACT_APP_MESSAGE_PORT;

const super_admin = parseInt(process.env.REACT_APP_SUPER_ADMIN_ID);
const admin = parseInt(process.env.REACT_APP_EVENT_ADMIN_ID);
const sub_admin = parseInt(process.env.REACT_APP_EVENT_SUB_ADMIN_ID);

const gForceChannelID = parseInt(process.env.REACT_APP_TELEMETRY_GFORCE_ID);
const supportedExtraChannels = parseInt(process.env.REACT_APP_SUPPORTED_EXTRA_CHANNELS);

// Counter to avoid flooding the server when updating CarList
let counter = 0;

//////////////////////////// MAIN COMPONENTS \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

class Dashboard extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            carID: null,
            eventID: -1,
            sessionID: -1,
            userID: -1,
            orderType: "position",
            dataSources: {
                speed: "OBD",
            },
            carList: [{
                id: 0,
                livery_number: 0,
                short_name: "---"
            }],
            carObj: {
                id: 0,
                livery_number: 0,
                short_name: "---",
                name: "---",
                speedSource: "OBD",
            },
            telemetry: {
                accel: [0, 0, 0],
                clt: 0,
                etm: 0,
                spg: 0,
                rpm: 0,
                spo: 0,
                thr: 0,
                ful: 0,
                ch0: 0,
                ch1: 0,
                ch2: 0,
                ch3: 0,
                ch4: 0,
                ch5: 0,
                ch6: 0,
                ch7: 0,
            },
            laps: {
                bst: 0,
                cnt: 0,
                lst: [
                    {time: 0, number: 0, max: 0}
                ]
            },
            isOwnTeam: 0,
            session: "---",
            circuit: "---",
            lengthType: "---",
            circuitLength: 0,
            circuitTimezone: "---",
            startTimestamp: 0,
            mapCenterLat: 0,
            mapCenterLng: 0,
            currentCarPosition: 0,
            pitlaneSpeedLimit: 0,
            sessionOver: false,
            standings: {
                std: [],
            },
            toggleCarList: false,
            activeTab: 0,
            sessionFlagStatus: [],
            sessionFlagIDs: [],
            flagList: [
                {id: -1, desc: "---", src: "none_transparent.png"}
            ],
            instructionFlag: null,
            correctSession: true,
            pendingMsgOrg: {},
            pendingMsgTeam: {},
            gaugesConfig: [],
            showSeatTime: 0,
            seatTimeLimitAlert: 0,
            sessionActive: -1,
            readyForRender: false,
            marshallPosts: [],
        };

        this.updateCurrentCarID = this.updateCurrentCarID.bind(this);
        this.updateYoutubeStream = this.updateYoutubeStream.bind(this);
        this.updateGaugesConfig = this.updateGaugesConfig.bind(this);
        this.updateSessionStatus = this.updateSessionStatus.bind(this);
        this.getCarList = this.getCarList.bind(this);
        this.getSessionDetails = this.getSessionDetails.bind(this);
        this.reOrderCarList = this.reOrderCarList.bind(this);
        this.closeCommand = this.closeCommand.bind(this);
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.updateActiveTab = this.updateActiveTab.bind(this);
        this.popoutLapTimes = this.popoutLapTimes.bind(this);
        this.popoutOrganizerPanel = this.popoutOrganizerPanel.bind(this);
        this.compareLivery = this.compareLivery.bind(this);
        this.getFlagList = this.getFlagList.bind(this);
        this.statusIDtoObj = this.statusIDtoObj.bind(this);
        this.statusParser = this.statusParser.bind(this);
        this.handleLangChange = this.handleLangChange.bind(this);
        this.setUpSocket = this.setUpSocket.bind(this);
        this.getMarshallPostList = this.getMarshallPostList.bind(this);
        this.preSelectTeamCar = this.preSelectTeamCar.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        if (this.props.location && this.props.location.state) {
            $('.loading').fadeIn();
            const helper = this;
            parallel([
                // Setup socket
                function (callback) {
                    helper.setUpSocket((status) => {
                        callback(null, status);
                    });
                },
                // get session details
                function (callback) {
                    helper.getSessionDetails((status) => {
                        callback(null, status);
                    });
                },
                // update car list
                function (callback) {
                    helper.getCarList(null, (status) => {
                        callback(null, status);
                    });
                },
                // get flag list
                function (callback) {
                    helper.getFlagList((status) => {
                        callback(null, status);
                    });
                },
                // get marshall posts list
                function (callback) {
                    helper.getMarshallPostList((status) => {
                        callback(null, status);
                    });
                },
            ], function (err, result) {
                console.log("[DASHBOARD] DATA FETCH COMPLETE");
            });

            this.props.i18n.changeLanguage(this.props.cookies.get("lang")).then(r => null);
        }
    }

    componentWillUnmount() {
        if (this.props.location && this.props.location.state) {
            // DS
            subscribeDashToServer(this.props.location.state.eventID, this.props.location.state.sessionID, () => {
                console.log("[DASHBOARD] DEDICATED STREAM UNSUBSCRIBED");
            });
            subscribeToStandingsInfo(this.props.location.state.eventID, true, null);
            subscribeToTelemetry(this.state.carID, null, true, null);
            subscribeToLapInfo(this.state.carID, null, true, null);
            subscribeOrgCommands(this.props.location.state.eventID, this.props.location.state.sessionID, true, null);
            subscribeSessionStatus(this.props.location.state.eventID, true, null);
            closeSocket();
        }
    }

    /* GET DATA */
    setUpSocket(callback) {
        if (this.props.location) {

            if (this.props.cookies.get("authToken") && !this.props.location.state.isGuest) {

                console.log("[DASHBOARD] AUTHENTICATED AS: ORGANIZER / TEAM MANAGER");

                // Connect socket
                connectSocket(this.props.cookies.get("authToken"), this.state.carID, this.props.location.state.sessionID, this.props.location.state.eventID, "DASHBOARD", (msg, correctEvent, correctSession) => {
                    console.log("[DASHBOARD]", msg);
                    // Subscribe dash connection
                    subscribeDashToServer(this.props.location.state.eventID, this.props.location.state.sessionID, (msg, correctEvent, correctSession) => {

                        console.log("[DASHBOARD] CORRECT SESSION:", correctSession);
                        console.log("[DASHBOARD] CORRECT EVENT:", correctEvent);

                        this.setState({
                            correctSession: true, // DEBUG ONLY, DELETE LATER
                            //correctSession: correctSession,
                            readyForRender: true, // Green Light for master render method
                        });

                        console.log("[DASHBOARD] DEDICATED STREAM SUBSCRIBED");
                    });

                    // Subscribe to standings info
                    subscribeToStandingsInfo(this.props.location.state.eventID, false, (err, standings) => {
                        counter++;
                        this.reOrderCarList(this.state.carList, standings.std, (newList) => {
                            if (JSON.stringify(this.state.carList) !== JSON.stringify(newList) || !this.state.bestLapOverall || (standings.obl < this.state.bestLapOverall)) {
                                // Update session's overall Best Lap
                                this.setState({
                                    bestLapOverall: standings.obl,
                                    standings: standings,
                                });
                            }
                        });
                        // Update CarList every 100 "standings" messages received
                        if (counter >= 100) {
                            this.getCarList(standings, null);
                            counter = 0;
                        }
                    });

                    // Subscribe to Org commands
                    subscribeOrgCommands(this.props.location.state.eventID, this.props.location.state.sessionID, false, (err, commands) => {
                        if (commands.cmd === "RT-ORG-SESSION-TIMER-RESET") {
                            console.log("[DASHBOARD] [ORG] SESSION TIMER RESET");
                            this.getSessionDetails((status) => {
                                Alert.info('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("sessionTimerReset") + '!</span>', {
                                    position: 'top-right',
                                    effect: 'genie',
                                    beep: false,
                                    timeout: 5000,
                                    offset: 150
                                });
                            });
                        } else if (commands.cmd === "RT-ORG-SESSION-RESET") {
                            console.log("[DASHBOARD] [ORG] SESSION DEVICES RESET");
                            this.getSessionDetails((status) => {
                                Alert.info('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("devicesReset") + '!</span>', {
                                    position: 'top-right',
                                    effect: 'genie',
                                    beep: false,
                                    timeout: 5000,
                                    offset: 150
                                });
                            });
                        } else if (commands.cmd === "RT-ORG-SESSION-CLOSE") {
                            console.log("[DASHBOARD] [ORG] SESSION CLOSE");
                            this.setState({
                                sessionOver: true,
                            });
                        } else if (commands.cmd === "RT-ORG-SESSION-CHANGE-LENGTH") {
                            console.log("[DASHBOARD] [ORG] SESSION LENGTH CHANGED");
                            this.getSessionDetails((status) => {
                                Alert.info('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("sessionLengthReset") + '!</span>', {
                                    position: 'top-right',
                                    effect: 'genie',
                                    beep: false,
                                    timeout: 5000,
                                    offset: 150
                                });
                            });
                        } else if (commands.cmd === "RT-ORG-SESSION-CHANGE-START") {
                            console.log("[DASHBOARD] [ORG] SESSION START TIMESTAMP CHANGE");
                            this.getSessionDetails((status) => {
                                Alert.info('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("sessionStartAdjust") + '!</span>', {
                                    position: 'top-right',
                                    effect: 'genie',
                                    beep: false,
                                    timeout: 5000,
                                    offset: 150
                                });
                            });
                        } else if (commands.cmd === "RT-ORG-SESSION-TIMER-START") {
                            console.log("[DASHBOARD] [ORG] SESSION TIMER START");
                            this.getSessionDetails((status) => {
                                Alert.info('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("sessionTimerStart") + '!</span>', {
                                    position: 'top-right',
                                    effect: 'genie',
                                    beep: false,
                                    timeout: 5000,
                                    offset: 150
                                });
                            });
                        } else {
                            console.log("[DASHBOARD] FROM ORG: Unknown command - " + commands.toString());
                        }
                    });

                    // Subscribe to Session Status
                    subscribeSessionStatus(this.props.location.state.eventID, false, (err, pack) => {
                        let sessionStatus = this.statusParser(pack.sts);
                        let sessionFlagStatus = this.statusIDtoObj(sessionStatus);
                        let instruction = null;
                        if (this.state.carID && pack.crs["" + this.state.carID]) {
                            instruction = this.statusIDtoObj([pack.crs["" + this.state.carID].ins])[0];
                        }
                        if (
                            JSON.stringify(this.state.sessionFlagIDs) !== JSON.stringify(sessionStatus) ||
                            JSON.stringify(this.state.instructionFlag) !== JSON.stringify(instruction) ||
                            JSON.stringify(this.state.pendingMsgOrg) !== JSON.stringify(pack.com) ||
                            JSON.stringify(this.state.pendingMsgTeam) !== JSON.stringify(pack.cgm)
                        ) {
                            this.setState({
                                sessionFlagIDs: sessionStatus,
                                sessionFlagStatus: sessionFlagStatus,
                                instructionFlag: instruction,
                                pendingMsgOrg: pack.com,
                                pendingMsgTeam: pack.cgm,
                            });
                        }
                    });
                });
            } else if (this.props.location.state.isGuest) {
                // Connect socket
                connectSocket(null, this.state.carID, this.props.location.state.sessionID, this.props.location.state.eventID, "DASHBOARD", (msg) => {
                    console.log("[DASHBOARD]" + msg);
                    subscribeDashToServer(this.props.location.state.eventID, this.props.location.state.sessionID, (msg, correctEvent, correctSession) => {
                        console.log("[DASHBOARD] DEDICATED STREAM SUBSCRIBED");
                        console.log("[DASHBOARD] CORRECT SESSION:", correctSession);
                        console.log("[DASHBOARD] CORRECT EVENT:", correctEvent);

                        this.setState({
                            //correctSession: true, // DEBUG ONLY, DELETE LATER
                            correctSession: correctSession,
                            readyForRender: true, // Green Light for master render method
                        });
                    });
                });
                // Is a guest at home (No authentication)
                console.log("[DASHBOARD] AUTHENTICATED AS: GUEST with eventShareCode:", this.props.location.state.eventShareCode);
            }
            callback("ok");
        } else {
            console.log("[DASHBOARD] AUTHENTICATION: INVALID ATTEMPT");
            window.history.back();
        }
    }

    getCarList(standings, callback) {
        console.log("[DASHBOARD] Mounting car list...");
        let carIDs = [];
        if (standings) {
            for (let i = 0; i < standings.std.length; i++) {
                carIDs.push(standings.std[i].cid);
            }
        }

        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getCarList',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
                'eventsharecode': helper.props.location.state.eventShareCode,
            },
            data: {
                sessionID: helper.props.location.state.sessionID,
                userID: helper.props.location.state.userID,
                carIDs: carIDs.toString(),
            },
            success: function (data) {
                helper.setState({
                    carList: data,
                }, () => {
                    if (standings) {
                        helper.reOrderCarList(helper.state.carList, standings.std, null);
                    }
                    if (callback) {
                        callback("ok");
                    }
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                helper.setState({
                    carList: [{
                        id: 0,
                        livery_number: 0,
                        short_name: "---",
                        name: "---",
                        speedSource: "OBD",
                    }]
                }, () => {
                    if (callback) {
                        callback("nok");
                    }
                });
            }
        });
    }

    getSessionDetails(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getSessionDetails',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
                'eventsharecode': helper.props.location.state.eventShareCode,
            },
            data: {
                sessionID: helper.props.location.state.sessionID,
            },
            success: function (data) {
                if (data) {
                    helper.setState({
                        session: data.session,
                        sessionActive: data.session_status,
                        sessionTypeID: data.session_type_id,
                        circuit: data.circuit,
                        lengthType: data.length_delimiter,
                        orderType: data.order_factor,
                        eventLength: data.length,
                        circuitLength: data.track_length,
                        circuitTimezone: data.timezone,
                        startTimestamp: data.start_timestamp,
                        scheduledStartTimestamp: data.scheduled_start_timestamp,
                        mapCenterLat: data.map_center_lat,
                        mapCenterLng: data.map_center_lng,
                        mapZoomLevel: data.map_center_zoom_level,
                        mapRotation: data.map_rotation,
                        pitlaneSpeedLimit: data.pitlane_speed_limit,
                        pitMinimumTime: data.pit_minimum_time,
                        lastReset: data.last_reset,
                    }, () => {
                        console.log("[DASHBOARD] COMPLETE getSessionDetails");
                        callback("ok");
                    });
                } else {
                    helper.setState({
                        sessionOver: true,
                    }, () => {
                        callback("nok");
                    });
                }
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getFlagList(callback) {
        const helper = this;
        $.ajax({
            type: 'GET',
            url: serverIP + ":" + backendPort + '/dashboard/getFlagList',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            success: function (data) {
                helper.setState({
                    flagList: data.collective.concat(data.singular).concat(data.fullCourse),
                }, () => {
                    callback("ok");
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                helper.setState({
                    flagList: [
                        {id: -1, desc: "---", src: "none_transparent.png"}
                    ],
                }, () => {
                    callback("nok");
                });
            }
        });
    }

    getMarshallPostList(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getMarshallPostList',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.location.state.sessionID,
            },
            success: function (data) {
                if (data && data.length > 0) {
                    helper.setState({
                        marshallPosts: data
                    });
                }
                callback("ok");
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    /* HANDLERS */
    preSelectTeamCar() {
        // Pre-select first car of team
        if (!(this.props.location.state.privileges.includes(super_admin) || this.props.location.state.privileges.includes(admin) || this.props.location.state.privileges.includes(sub_admin))) {
            console.log("[DASHBOARD] Manager detected, pre-selecting vehicle ...");
            const helper = this;
            $.ajax({
                type: 'POST',
                url: serverIP + ":" + backendPort + '/dashboard/getCarByManagerID',
                headers: {
                    'authorization': helper.props.cookies.get("authToken"),
                },
                data: {
                    userID: helper.props.location.state.userID,
                    sessionID: helper.props.location.state.sessionID,
                },
                success: function (data) {
                    if (data.length > 0) {
                        helper.updateCurrentCarID(data[0].id, 1, null);
                    }
                    $('.loading').fadeOut();
                }, error: function (err) {
                    if (err) {
                        console.error('Error:', err);
                    }
                }
            });
        } else {
            $('.loading').fadeOut();
        }
    }

    reOrderCarList(oldList, newList, callback) {
        let orderedList = [];

        for (let i = 0; i < newList.length; i++) {
            for (let j = 0; j < oldList.length; j++) {
                if (this.state.carID === oldList[j].id) {
                    if (this.state.currentCarPosition !== (j + 1) || this.state.currentCarPosition === 0) {
                        this.setState({
                            currentCarPosition: (j + 1),
                        });
                    }
                }
                if (oldList[j].id === newList[i].cid) {
                    oldList[j]["data"] = newList[i];
                    if (i === 0) {
                        if (this.state.orderType === "position") {
                            oldList[j]["gap"] = "Lap " + newList[i].lct + " | " + formatTime(newList[i].llt);
                        } else if (this.state.orderType === "bestlap") {
                            oldList[j]["gap"] = formatTime(newList[i].blt);
                        }
                    } else {
                        if (this.state.orderType === "position") {
                            oldList[j]["gap"] = "Lap " + newList[i].lct + " | " + formatTime(newList[i].llt);
                        } else if (this.state.orderType === "bestlap") {
                            if (newList[i].blt !== null) {
                                oldList[j]["gap"] = "+" + Math.abs(newList[0].blt - newList[i].blt) / 1000 + "s";
                            } else {
                                oldList[j]["gap"] = "---";
                            }
                        }
                    }
                    orderedList.push(oldList[j]);
                    break;
                }
            }
        }

        // Override ordering - TESTING PURPOSES -
        if (this.state.orderType === "position") {
            orderedList.sort(this.compareLivery);
        }

        this.setState({
            carList: orderedList,
        }, () => {
            if (callback) {
                callback(orderedList);
            }
        });
    }

    compareLivery(a, b) {
        if (a.livery_number < b.livery_number) {
            return -1;
        } else if (a.livery_number > b.livery_number) {
            return 1;
        }
    }

    statusIDtoObj(arr) {
        let temp = [];
        if (arr && arr.length > 0) {
            for (let i = 0; i < arr.length; i++) {
                temp.push(null);
                for (let j = 0; j < this.state.flagList.length; j++) {
                    if (this.state.flagList[j].id === arr[i]) {
                        temp[i] = this.state.flagList[j];
                        break;
                    }
                }
            }
            return temp;
        } else {
            for (let i = 0; i < this.state.marshallPosts.length; i++) {
                temp.push(null);
            }
            return temp;
        }
    }

    statusParser(sts) {
        let newStatus = [];
        let found = false;

        for (let p = 0; p < this.state.marshallPosts.length; p++) {

            found = false;

            for (let s = 0; s < Object.keys(sts).length; s++) {
                if (this.state.marshallPosts[p].order_no === parseInt(Object.keys(sts)[s])) {
                    newStatus.push(sts[Object.keys(sts)[s]]);
                    found = true;
                    break;
                }
            }

            if (!found) {
                newStatus.push(0);
            }
        }

        return newStatus;
    }

    closeCommand() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: telemetryIP + ':' + telemetryPort + '/command-worker-device?command=RT-ORG-SESSION-CLOSE&eventId=' + helper.props.location.state.eventID + '&sessionId=' + helper.props.location.state.sessionID,
            headers: {
                'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
            },
            dataType: 'json',
            success: function () {
                console.log('[DASHBOARD] Successfully sent session reset request.');
            }, error: function (err) {
                if (err)
                    console.error('[DASHBOARD] Error sending session reset request.');
            }
        });
    }

    toggleSidebar(callback) {
        this.setState({
            toggleCarList: !this.state.toggleCarList,
        }, () => {
            callback(this.state.toggleCarList);
        });
    }

    updateSessionStatus(status) {
        $('.loading').fadeIn();
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/closeSession',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.location.state.sessionID,
                endDate: Moment().unix(),
            },
            success: function () {
                helper.closeCommand();
                helper.setState({
                    sessionOver: status,
                }, () => {
                    Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("sessionNowClosed") + '</span>', {
                        position: 'top-right',
                        effect: 'genie',
                        beep: false,
                        timeout: 5000,
                        offset: 150
                    });
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
            }
        });
    }

    updateCurrentCarID(newCarID, isOwnTeam, speedSource) {
        // Save the car object
        for (let i = 0; i < this.state.carList.length; i++) {
            if (this.state.carList[i].id === newCarID) {
                this.setState({
                    carObj: this.state.carList[i],
                    youtubeStream: this.state.carList[i].youtube_stream,
                });
                break;
            }
        }
        // Save the carID currently in state to avoid assynchronism issues when updating
        let currentCarID = this.state.carID;

        let newTelemetryObj = {
            accel: [0, 0, 0],
            clt: 0,
            etm: 0,
            spg: 0,
            rpm: 0,
            spo: 0,
            thr: 0,
            ful: 0,
        };

        for (let i = 0; i < supportedExtraChannels; i++) {
            newTelemetryObj[("ch" + i)] = 0;
        }

        this.setState({
            telemetry: newTelemetryObj,
            laps: {
                bst: 0,
                cnt: 0,
                lst: [
                    {time: 0, number: 0, max: 0}
                ]
            },
        }, () => {

            forceReconnect(newCarID, this.props.location.state.sessionID, this.props.location.state.eventID, (msg) => {
                console.log("[DASHBOARD][HANDLER REDECLARATION]" + msg);
            });

            // Notify server of new connection
            subscribeCarToServer(this.props.location.state.eventID, newCarID, (err, pack) => {
                console.log("[DASHBOARD] CAR ", pack.carId, " SUBSCRIBED EVENT", pack.eventId);
            });

            // Connecto to telemetry feed
            let streamSuffix;
            if (this.props.location.state.privileges.includes(super_admin) || this.props.location.state.privileges.includes(admin) || this.props.location.state.privileges.includes(sub_admin)) {
                streamSuffix = "-telemetry-data";
            } else {
                if (
                    this.props.location.state.isGuest || isOwnTeam === 0) {
                    streamSuffix = "-public-telemetry-data";
                } else {
                    streamSuffix = "-telemetry-data";
                }
            }
            subscribeToTelemetry(currentCarID ? ("car_" + currentCarID + streamSuffix) : null, ("car_" + newCarID + streamSuffix), false, (err, telemetry) => {
                // Convert G's
                let accel;
                if (telemetry.xyz) {
                    accel = [
                        telemetry.xyz[0] / 1000,
                        telemetry.xyz[1] / 1000,
                        telemetry.xyz[2] / 1000,
                    ];
                } else if (telemetry["ch" + gForceChannelID]) {
                    accel = [0, 0, 0];
                } else {
                    accel = [0, 0, 0];
                }

                let newTelemetryState = {
                    accel: accel,
                    clt: ((telemetry.clt !== undefined) ? telemetry.clt : this.state.telemetry.clt),
                    etm: ((telemetry.etm !== undefined) ? telemetry.etm : this.state.telemetry.etm),
                    spo: ((telemetry.spo !== undefined) ? telemetry.spo : this.state.telemetry.spo),
                    spg: ((telemetry.spg !== undefined) ? telemetry.spg : this.state.telemetry.spg),
                    rpm: ((telemetry.rpm !== undefined) ? telemetry.rpm : this.state.telemetry.rpm),
                    thr: ((telemetry.thr !== undefined) ? telemetry.thr : this.state.telemetry.thr),
                    ful: ((telemetry.ful !== undefined) ? telemetry.ful : this.state.telemetry.ful),
                    pli: ((telemetry.pli !== undefined) ? telemetry.pli : this.state.telemetry.pli),
                    srt: ((telemetry.srt !== undefined) ? telemetry.srt : this.state.telemetry.srt),
                    pet: ((telemetry.pet !== undefined) ? telemetry.pet : this.state.telemetry.pet),
                };

                for (let i = 0; i < supportedExtraChannels; i++) {
                    newTelemetryState[("ch" + i)] = ((telemetry[("ch" + i)] !== undefined) ? telemetry[("ch" + i)] : this.state.telemetry[("ch" + i)]);
                }

                // Save in state
                this.setState({
                    telemetry: newTelemetryState,
                });
            });

            // Connect to Laps Info feed
            subscribeToLapInfo(currentCarID, newCarID, false, (err, laps) => {
                try {
                    if (laps.lst.length > 0) {
                        this.setState({
                            laps: laps,
                        });
                    }
                } catch (e) {
                    console.log("[DASHBOARD] ERROR: NO LAPS?", e);
                }
            });

            // Update state
            this.setState({
                carID: newCarID,
                isOwnTeam: isOwnTeam,
            }, () => {
                // Update state after
                console.log("[DASHBOARD] UPDATED CAR ID");
            });
        });
    }

    updateGaugesConfig(newConfig, speedSource, showSeatTime, seatTimeLimitAlert) {
        console.log("[DASHBOARD] UPDATED TELEMETRY CONFIGS");
        this.setState({
            gaugesConfig: newConfig,
            speedSource: speedSource,
            showSeatTime: showSeatTime,
            seatTimeLimitAlert: seatTimeLimitAlert,
        });
    }

    updateYoutubeStream(carID, youtubeStream) {
        for (let i = 0; i < this.state.carList.length; i++) {
            if (this.state.carList[i].id === carID) {
                this.setState({
                    youtubeStream: youtubeStream,
                });
                console.log("[DASHBOARD] Youtube Stream updated!");
                break;
            }
        }
    }

    updateActiveTab(e) {
        this.setState({
            activeTab: e,
        }, () => {
            if (e === 0) {
                this.updateCurrentCarID(this.state.carID, this.state.isOwnTeam, null);
            }
        });
    }

    handleLangChange(event) {
        let newlang = event.target.id;
        this.setState({lang: newlang});
        this.props.i18n.changeLanguage(newlang);
        this.props.cookies.set("lang", newlang, {"path": "/", "maxAge": (4 * 24 * 60 * 60)});
    }

    /* POPOUT METHODS */
    popoutLapTimes() {
        window.open(
            "expandLapTimes/" + this.props.location.state.eventID + "/" + this.props.location.state.sessionID + "/" + this.state.carID,
            'lapTimes',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,eft=100,top=100,height=750,width=900"
        );
    }

    popoutOrganizerPanel() {
        window.open(
            "organizerPanel/" + this.props.location.state.userID + "/" + this.props.location.state.eventID + "/" + this.props.location.state.sessionID,
            'orgPanel',
            "scrollbars=no,resizable=yes,status=no,location=no,toolbar=no,menubar=no,left=200,top=100,height=750,width=1000"
        );
    }

    render() {
        if (!this.props.location.state) {
            return (
                <Redirect to={{pathname: "external-redirect/logout"}}/>
            );
        } else if (this.state.sessionOver) {
            if (this.props.location.state.isGuest) {
                return (
                    <Redirect
                        to={{
                            pathname: "/public/" + this.props.location.state.eventShareCode,
                            state: {
                                eventDate: -1,
                                message: "Session Finished",
                            }
                        }}
                    />
                );
            } else {
                return (
                    <Redirect
                        to={{
                            pathname: "/sessionChoice",
                            state: {
                                userID: this.props.location.state.userID,
                                privileges: this.props.location.state.privileges,
                            }
                        }}
                    />
                );
            }
        } else if (!this.state.correctSession) {
            return (
                <Redirect
                    to={{
                        pathname: "/sessionChoice",
                        state: {
                            userID: this.props.location.state.userID,
                            privileges: this.props.location.state.privileges,
                        }
                    }}
                />
            );
        } else {
            return (
                <div className={"container-fluid"} id={"mainDashboard"} style={{margin: 0, width: "100%"}}>
                    {(this.state.readyForRender) ? (
                        <>
                            <div className={"loading"}>
                                <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                            </div>
                            <Alert stack={{limit: 10}} html={true}/>
                            {(this.state.marshallPosts && this.state.marshallPosts.length) > 0 ? (
                                <FlagModal
                                    sessionID={this.props.location.state.sessionID}
                                    eventID={this.props.location.state.eventID}
                                    carID={this.state.carID}
                                    convertFlags={this.statusIDtoObj}
                                    marshallPosts={this.state.marshallPosts}
                                />
                            ) : null}
                            <CarTables
                                isGuest={this.props.location.state.isGuest}
                                carID={this.state.carID}
                                carList={this.state.carList}
                                updateCurrentCarID={this.updateCurrentCarID}
                                sessionID={this.props.location.state.sessionID}
                                eventID={this.props.location.state.eventID}
                                userID={this.props.location.state.userID}
                                toggleCarList={this.state.toggleCarList}
                                toggleSidebar={this.toggleSidebar}
                                sessionTypeID={this.state.sessionTypeID}
                                privileges={this.props.location.state.privileges}
                            />
                            <div className={"row"} id={"main"}>
                                <HeaderRow
                                    session={this.state.session}
                                    circuit={this.state.circuit}
                                    lengthType={this.state.lengthType}
                                    eventLength={this.state.eventLength}
                                    startTimestamp={this.state.startTimestamp}
                                    scheduledStartTimestamp={this.state.scheduledStartTimestamp}
                                    updateCurrentCarID={this.updateCurrentCarID}
                                    updateSessionStatus={this.updateSessionStatus}
                                    updateGaugesConfig={this.updateGaugesConfig}
                                    isOwnTeam={this.state.isOwnTeam}
                                    isGuest={this.props.location.state.isGuest}
                                    carID={this.state.carID}
                                    userID={this.props.location.state.userID}
                                    managerID={this.state.carObj.managerID}
                                    eventID={this.props.location.state.eventID}
                                    sessionID={this.props.location.state.sessionID}
                                    toggleCarList={this.state.toggleCarList}
                                    toggleSidebar={this.toggleSidebar}
                                    sessionFlagStatus={this.state.sessionFlagStatus}
                                    privileges={this.props.location.state.privileges}
                                    handleLangChange={this.handleLangChange}
                                    marshallPosts={this.state.marshallPosts}
                                    updateYoutubeStream={this.updateYoutubeStream}
                                />

                                <ul className={"organizerPanel_title nav nav-tabs"} role={"tablist"}>
                                    <li className={"active"}>
                                        <a href={"#mainDash"} role={"tab"} data-toggle={"tab"} onClick={() => this.updateActiveTab(0)}>
                                            {this.props.t("main").toUpperCase()}
                                        </a>
                                    </li>
                                    {!this.props.location.state.isGuest ? (
                                        <li className={(
                                            this.state.carID && (this.state.isOwnTeam === 1 || (this.props.location.state.privileges.includes(super_admin) || this.props.location.state.privileges.includes(admin) || this.props.location.state.privileges.includes(sub_admin))) ? "" : "disabled")}>
                                            <a href={"#lapTimes"} role={"tab"} data-toggle={"tab"} onClick={() => this.updateActiveTab(1)}>
                                                {this.props.t("lapTimes").toUpperCase()}
                                            </a>
                                        </li>) : null}
                                    {(this.props.location.state.privileges.includes(super_admin) || this.props.location.state.privileges.includes(admin) || this.props.location.state.privileges.includes(sub_admin)) ? (
                                        <li>
                                            <a href={"#organizerPanel"} role={"tab"} data-toggle={"tab"} onClick={() => this.updateActiveTab(2)}>
                                                {this.props.t("organizerPanel").toUpperCase()}
                                            </a>
                                        </li>
                                    ) : null}
                                </ul>
                                <div className={"tab-content w3-animate-fading"}>
                                    <div className={"tab-pane fade active in"} id={"mainDash"} style={{textAlign: "left"}}>
                                        <TopRow
                                            isGuest={this.props.location.state.isGuest}
                                            carID={this.state.carID}
                                            carObj={this.state.carObj}
                                            eventID={this.props.location.state.eventID}
                                            sessionID={this.props.location.state.sessionID}
                                            telemetry={this.state.telemetry}
                                            bestLapOverall={this.state.bestLapOverall}
                                            bestLapPersonal={this.state.laps.bst ? this.state.laps.bst : null}
                                            standings={this.state.standings}
                                            orderType={this.state.orderType}
                                            laps={this.state.laps}
                                            numLaps={this.state.laps.cnt}
                                            isOwnTeam={this.state.isOwnTeam}
                                            circuitLength={this.state.circuitLength}
                                            currentCarPosition={this.state.currentCarPosition}
                                            eventShareCode={this.props.location.state.eventShareCode}
                                            youtubeStream={(this.state.youtubeStream ? this.state.youtubeStream : "")}
                                            userID={this.props.location.state.userID}
                                            instructionFlag={this.state.instructionFlag}
                                            convertFlags={this.statusIDtoObj}
                                            privileges={this.props.location.state.privileges}
                                            pendingMsgOrg={this.state.pendingMsgOrg}
                                            pendingMsgTeam={this.state.pendingMsgTeam}
                                            gaugesConfig={this.state.gaugesConfig}
                                            speedSource={this.state.speedSource}
                                            showSeatTime={this.state.showSeatTime}
                                            seatTimeLimitAlert={this.state.seatTimeLimitAlert}
                                            sessionActive={this.state.sessionActive}
                                            startTimestamp={this.state.startTimestamp}
                                            marshallPosts={this.state.marshallPosts}
                                            preSelectTeamCar={this.preSelectTeamCar}
                                        />
                                        <MiddleRow
                                            eventID={this.props.location.state.eventID}
                                            mapCenterLat={this.state.mapCenterLat}
                                            mapCenterLng={this.state.mapCenterLng}
                                            circuitTimezone={this.state.circuitTimezone}
                                        />
                                        <BottomRow
                                            isGuest={this.props.location.state.isGuest}
                                            isOwnTeam={this.state.isOwnTeam}
                                            eventID={this.props.location.state.eventID}
                                            sessionID={this.props.location.state.sessionID}
                                            carID={this.state.carID}
                                            carList={this.state.carList}
                                            youtubeStream={(this.state.youtubeStream ? this.state.youtubeStream : "")}
                                            updateCurrentCarID={this.updateCurrentCarID}
                                            mapCenterLat={this.state.mapCenterLat}
                                            mapCenterLng={this.state.mapCenterLng}
                                            mapZoomLevel={this.state.mapZoomLevel}
                                            mapRotation={this.state.mapRotation}
                                            toggleCarList={this.state.toggleCarList}
                                            activeTab={this.state.activeTab}
                                            sessionFlagStatus={this.state.sessionFlagStatus}
                                            privileges={this.props.location.state.privileges}
                                            telemetry={this.state.telemetry}
                                            marshallPosts={this.state.marshallPosts}
                                            pitlaneSpeedLimit={this.state.pitlaneSpeedLimit}
                                            pitMinimumTime={this.state.pitMinimumTime}
                                        />
                                    </div>
                                    {!this.props.location.state.isGuest ? (
                                        <div className={"tab-pane fade disabled"} id={"lapTimes"} style={{textAlign: "left"}}>
                                            <div className={"col-xs-12 App_sectionContainer"} style={{borderRadius: "0 0 35px 0"}}>
                                                <button
                                                    type={"button"}
                                                    data-tip={true}
                                                    data-for={"fullLapTimes"}
                                                    className={"btn btn-primary btn-block button App_header"}
                                                    onClick={this.popoutLapTimes}
                                                    disabled={!(this.props.location.state.privileges.includes(super_admin) || this.props.location.state.privileges.includes(admin) || this.props.location.state.privileges.includes(sub_admin)) && this.state.isOwnTeam === 0}
                                                >
                                                    {this.props.t("dedicatedWindow")} <i className={"far fa-window-restore App_buttonContainer_icons"}/>
                                                </button>
                                                <ReactTooltip id={"fullLapTimes"} type={"light"}>
                                                    <span className={"toolTipStyle"}>{this.props.t("clickDedicatedWindow")}</span>
                                                </ReactTooltip>
                                                <PopoutLapTimes
                                                    isActive={this.state.activeTab}
                                                    sessionID={this.props.location.state.sessionID}
                                                    eventID={this.props.location.state.eventID}
                                                    privileges={this.props.location.state.privileges}
                                                    carID={this.state.carID}
                                                    isOwnTeam={this.state.isOwnTeam}
                                                    toggleCarList={this.state.toggleCarList}
                                                    circuitLength={this.state.circuitLength}
                                                    circuitTimezone={this.state.circuitTimezone}
                                                    startTimestamp={this.state.startTimestamp}
                                                    lastReset={this.state.lastReset}
                                                />
                                            </div>
                                        </div>
                                    ) : null}
                                    <div className={"tab-pane fade"} id={"organizerPanel"} style={{textAlign: "left"}}>
                                        <div className={"col-xs-12 App_sectionContainer"} style={{borderRadius: "0 0 35px 0"}}>
                                            <button
                                                type={"button"}
                                                data-tip={true}
                                                data-for={"organizer"}
                                                className={"btn btn-block button App_header"}
                                                onClick={this.popoutOrganizerPanel}
                                            >
                                                {this.props.t("dedicatedWindow")} <i className={"far fa-window-restore App_buttonContainer_icons"}/>
                                            </button>
                                            <ReactTooltip id={"organizer"} type={"light"}>
                                                <span className={"toolTipStyle"}>{this.props.t("clickDedicatedWindow")}</span>
                                            </ReactTooltip>
                                            {(this.props.location.state.privileges.includes(super_admin) || this.props.location.state.privileges.includes(admin) || this.props.location.state.privileges.includes(sub_admin)) ? (
                                                <OrganizerPanel
                                                    isActive={this.state.activeTab}
                                                    sessionID={this.props.location.state.sessionID}
                                                    eventID={this.props.location.state.eventID}
                                                    userID={this.props.location.state.userID}
                                                    toggleCarList={this.state.toggleCarList}
                                                    activeTab={this.state.activeTab}
                                                    carList={this.state.carList}
                                                />
                                            ) : (
                                                <div/>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <PortraitModal/>
                        </>
                    ) : (
                        <div/>
                    )}
                </div>
            );
        }
    }
}

export default withTranslation("translations")(withCookies(Dashboard));
